import { useMemo } from 'react';

import { useDynamicTags } from '@interlayer/js/custom/hooks/useDynamicTags';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/custom/utils/constants';

type TTagListProps = {
    tagName: DYNAMIC_TAG_NAMES;
    isNumber?: false;
    defaultValue?: string;
    withLowerCase?: boolean;
}

type TTagListPropsWithNumber = Omit<TTagListProps, 'isNumber'> & {
    isNumber: true;
}

type TUseDynamicTagList = {
    (data: TTagListProps): string[];
    (data: TTagListPropsWithNumber): number[];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useDynamicTagList:TUseDynamicTagList = ({ tagName, isNumber, defaultValue = '', withLowerCase = true }): any[] => {
    const [dTag = defaultValue] = useDynamicTags([tagName]);

    return useMemo(() => {
        return dTag
            .split(',')
            .map((item) => {
                if (isNumber) {
                    return Number(item.trim());
                }

                if (withLowerCase) {
                    return item.trim().toLowerCase();
                }

                return item.trim();
            })
            .filter(Boolean);
    }, [dTag, isNumber, withLowerCase]);
};
